import React from 'react';
import { AlertCircle, X } from 'lucide-react';

export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel, isDangerous = false, isLoading = false }) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-lg)',
        width: '90%',
        maxWidth: 400,
        padding: 24,
        animation: 'slideUp 0.2s ease'
      }}>
        <div style={{display:'flex', alignItems:'flex-start', gap:12}}>
          <div style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: isDangerous ? 'var(--danger-light)' : 'var(--warning-light)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <AlertCircle size={20} color={isDangerous ? 'var(--danger)' : 'var(--warning)'} />
          </div>
          <div style={{flex: 1}}>
            <h3 style={{margin: '0 0 8px 0', fontSize: '1rem', fontWeight: 600, color: 'var(--gray-900)'}}>
              {title}
            </h3>
            <p style={{margin: 0, fontSize: '0.875rem', color: 'var(--gray-600)', lineHeight: 1.5}}>
              {message}
            </p>
          </div>
          <button 
            onClick={onCancel}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              color: 'var(--gray-400)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <X size={18} />
          </button>
        </div>
        
        <div style={{display:'flex', gap:12, marginTop:20}}>
          <button
            onClick={onCancel}
            className="btn btn-ghost"
            style={{flex: 1}}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`btn ${isDangerous ? 'btn-danger' : 'btn-primary'}`}
            style={{flex: 1, opacity: isLoading ? 0.6 : 1}}
            disabled={isLoading}
          >
            {isLoading ? 'Deleting...' : isDangerous ? 'Delete' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
